/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserEventDTO
 */
export interface UserEventDTO {
    /**
     * 
     * @type {string}
     * @memberof UserEventDTO
     */
    action: string;
    /**
     * Action version, expected to be in range 0-255 (1 byte)
     * @type {number}
     * @memberof UserEventDTO
     */
    actionVersion: number;
    /**
     * 
     * @type {string}
     * @memberof UserEventDTO
     */
    metadata?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEventDTO
     */
    organizationID?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEventDTO
     */
    projectId?: string;
    /**
     * 
     * @type {number}
     * @memberof UserEventDTO
     */
    timestampMillis: number;
    /**
     * 
     * @type {string}
     * @memberof UserEventDTO
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof UserEventDTO
     */
    username?: string;
}

/**
 * Check if a given object implements the UserEventDTO interface.
 */
export function instanceOfUserEventDTO(value: object): value is UserEventDTO {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('actionVersion' in value) || value['actionVersion'] === undefined) return false;
    if (!('timestampMillis' in value) || value['timestampMillis'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function UserEventDTOFromJSON(json: any): UserEventDTO {
    return UserEventDTOFromJSONTyped(json, false);
}

export function UserEventDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEventDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'actionVersion': json['actionVersion'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'organizationID': json['organizationID'] == null ? undefined : json['organizationID'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'timestampMillis': json['timestampMillis'],
        'url': json['url'],
        'username': json['username'] == null ? undefined : json['username'],
    };
}

export function UserEventDTOToJSON(value?: UserEventDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'action': value['action'],
        'actionVersion': value['actionVersion'],
        'metadata': value['metadata'],
        'organizationID': value['organizationID'],
        'projectId': value['projectId'],
        'timestampMillis': value['timestampMillis'],
        'url': value['url'],
        'username': value['username'],
    };
}

